export default "<p>\r\n  auth works!\r\n</p>\r\n";